import { z } from "zod";
/**
 * ブックマーク（保存済み案件）一覧のクエリ。
 * 会員(MEMBER)自身の保存済み案件を返す `GET /bookmarks` に渡す。
 * 検索・企業・ステータスの絞り込みはクライアント側（保存済みページ）で行うため、
 * サーバーはページングのみ受け取る（マイ応募の全件取得と同じ方針）。
 */
export const bookmarkListQuerySchema = z.object({
    // 深いオフセットによるコストアンプを避けるため page に上限を設ける（応募一覧と揃える）。
    page: z.coerce.number().int().min(1).max(10_000).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
